import { render, staticRenderFns } from "./ListDefaultWebpartTest.vue?vue&type=template&id=2c744988"
import script from "./ListDefaultWebpartTest.vue?vue&type=script&lang=js"
export * from "./ListDefaultWebpartTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports